import { useCallback } from "react";
import { isFreeTrialActive } from "@jti/fe-common";
import { fetchFreeTrialOrder, fetchOrder, getOrderItemsWithFormattedPrice, useDispatch, useSelector } from "@jti/store";
import { useFreeTrial } from "../hooks/useFreeTrial";
import { useLoyaltyStatus } from "../hooks/useLoyaltyStatus";
export const useOrder = () => {
    const dispatch = useDispatch();
    const hasLoyalty = useLoyaltyStatus();
    const { isFreeTrial, freeTrialOrderState } = useFreeTrial();
    const currency = useSelector((state) => state.cart.currency);
    const { points, pending_points } = useSelector((state) => state.loyalty);
    const { orderDetails, paymentMethod, contactEmail, points: earnedPoints } = useSelector((state) => state.order);
    const { paymentMethod: freeTrialPaymentMethod, contactEmail: freeTrialContactEmail, points: freeTrialEarnedPoints, orderDetails: freeTrialOrder, } = freeTrialOrderState;
    const fetchOrderCallback = useCallback((orderId) => {
        if (isFreeTrialActive() && isFreeTrial) {
            dispatch(fetchFreeTrialOrder(orderId));
        }
        else {
            dispatch(fetchOrder(orderId));
        }
    }, [isFreeTrial, dispatch]);
    const orderData = isFreeTrial ? freeTrialOrder.data : orderDetails?.data;
    const currentOrder = getOrderItemsWithFormattedPrice(orderData, currency);
    const orderFetchStatus = isFreeTrial ? freeTrialOrder.fetchStatus : orderDetails.fetchStatus;
    const summaryPrices = isFreeTrial ? freeTrialOrder.data?.prices : currentOrder?.prices;
    return {
        orderFetchStatus,
        order: currentOrder,
        fetchOrder: fetchOrderCallback,
        contactEmail: isFreeTrial ? freeTrialContactEmail : contactEmail,
        paymentMethod: isFreeTrial ? freeTrialPaymentMethod : paymentMethod,
        earnedPoints: isFreeTrial ? freeTrialEarnedPoints : earnedPoints,
        hasLoyalty,
        points,
        pending_points,
        isFreeTrial,
        summaryPrices,
    };
};
//# sourceMappingURL=useOrder.js.map